var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"board-card gl-p-5 gl-rounded-base",class:{
    'multi-select': _vm.multiSelectVisible,
    'user-can-drag': _vm.isDraggable,
    'is-disabled': _vm.isDisabled,
    'is-active': _vm.isActive,
    'gl-cursor-not-allowed gl-bg-gray-10': _vm.item.isLoading,
  },attrs:{"data-qa-selector":"board_card","index":_vm.index,"data-item-id":_vm.item.id,"data-item-iid":_vm.item.iid,"data-item-path":_vm.item.referencePath,"data-testid":"board_card"},on:{"click":function($event){return _vm.toggleIssue($event)}}},[_c('board-card-inner',{attrs:{"list":_vm.list,"item":_vm.item,"update-filters":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }